<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import Visitors from "../../components/widgets/visitors.vue";
import Barras from "../../components/widgets/barras.vue";
import Stat from "../../components/widgets/stat";
import {
    linewithDataChart,
    dashedLineChart,
    splineAreaChart,
    columnChart,
    columnDatalabelChart,
    barChart,
    mixedChart,
    radialChart,
    pieChart,
    donutChart
} from "./data-apex";

export default {
    components: { Layout, PageHeader, DatePicker ,Visitors, Barras},
    data() {
        return {
            title: "Reportabilidad",
            items: [
                {
                    text: "Utilidad",
                    href: "/"
                },
                {
                    text: "Inicio",
                    active: true
                }
            ],
            colores1:["#6f42c1", "#FF0000", "#25d366", "#3FC060" , "#ffffff"],
            colores2:["#FF0000", "#4AC14B", "#FF7F0D", "#1E3E71" , "#EFC84E"],
            articulos_mes: [],
            articulos_dia: [],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "age",
            sortDesc: false,
            fields: [
                { key: "index", label: "#", sortable: true },
                { key: "nombre", label: "NOMBRE", sortable: true },
                { key: "stock_mes_anterior", label: "INGRESOS/MES_PASADO", sortable: false },
                { key: "stock_mes", label: "INGRESOS/MES", sortable: false },
            ],
            categorias:[],
            series_canal:[],
            series_tipo_ingreso:[],
            dates:'',
            datosListos: false,
            datosDiasListos: false,
            datos_hoy:{},
            // Grafico para mostrar las ventas por mes
            totalVentasAñoAnterior:1,
            productos_mas_vendidos:'',
            eje_x_ingresos:['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            ingresos_general: [
                // Agregar las ventas totales por mes actual
                { name: 'Ventas Totales', data: [] },
            ],
            // Graficos de barras, uno por cada categoria (Hamburguesas, Bebestibles, Acompañamiento) en donde muestra los top 10 en ventas de cada categoria
            // para hamburguesas
            barChart_Waffles : {
                series: [{
                    // numero de ventas mensual de los 10 mas vendidos
                    data: []
                }],
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: true,
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    dataLabels: {
                        enabled: true
                    },
                    colors: ['#34c38f'],
                    grid: {
                        borderColor: '#f1f1f1',
                    },
                    xaxis: {
                         // nombre de los 10 mas vendidos
                        categories: [],
                    }
                }
            },
            // para grafico de bebestibles
            barChart_Completos : {
                series: [{
                    data: []
                }],
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: true,
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    dataLabels: {
                        enabled: true
                    },
                    colors: ['#34c38f'],
                    grid: {
                        borderColor: '#f1f1f1',
                    },
                    xaxis: {
                        categories: [],
                    }
                }
            },
            // para grafico de acompañamiento
            barChart_Cafes : {
                series: [{
                    data: []
                }],
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: true,
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    dataLabels: {
                        enabled: true
                    },
                    colors: ['#34c38f'],
                    grid: {
                        borderColor: '#f1f1f1',
                    },
                    xaxis: {
                        categories: [],
                    }
                }
            },
            top10ProductosChart: {
                series: [{
                    name: 'Cantidad vendida',
                    data: []
                }],
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: true,
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    dataLabels: {
                        enabled: true
                    },
                    colors: ['#6f42c1'],
                    grid: {
                        borderColor: '#f1f1f1',
                    },
                    xaxis: {
                        categories: [],
                    }
                }
            },
            
        };
    },
    methods: {
        exportData(){
            let datesI=this.convertToStandardFormat(this.dates[0])
            let datesF=this.convertToStandardFormat(this.dates[1])
            let payload={
                datesI:datesI,
                datesF:datesF,
            }
            axios({
                url: '/api/get_range_pedidos', 
                data: payload, // URL de la solicitud GET
                method: 'POST', // Método de la solicitud
                responseType: 'blob', // Tipo de respuesta: archivo blob
            }).then(response => { // Función a ejecutar cuando la solicitud se complete con éxito
                // Crear una URL de objeto para el archivo blob
                const url = window.URL.createObjectURL(new Blob([response.data]));

                // Obtener el encabezado Content-Disposition que contiene el nombre de archivo
                const disposition = response.headers['content-disposition'];

                // Extraer el nombre de archivo del encabezado Content-Disposition
                const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
                const filename = matches[1].replace(/['"]/g, '');

                // Crear un enlace y configurar la URL y el nombre de archivo para la descarga
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);

                // Agregar el enlace al cuerpo del documento, simular un clic en el enlace y eliminarlo después
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.isLoading = false;
            }).catch(error => { // Función a ejecutar si hay un error en la solicitud
                console.error('Error al descargar el archivo CSV', error);
                this.isLoading = false;
            });
        },
        convertToStandardFormat(date) {
            const [day, month, year] = date.split('-');
            return `${year}-${month}-${day}`;
        },
        agruparProductosPorTipo(productos) {
            const tiposPorDefecto = ["Waffles", "Completos", "Cafes"]; // Lista de tipos `def` por defecto

            return productos.reduce((acc, producto) => {
                // Si el tipo no existe en el acumulador, inicialízalo como un array vacío
                if (!acc[producto.def]) {
                    acc[producto.def] = [];
                }
                // Añade el producto al array correspondiente
                acc[producto.def].push(producto);
                return acc;
            }, 
            // Inicializar el acumulador con los tipos por defecto
            tiposPorDefecto.reduce((acc, tipo) => {
                acc[tipo] = [];
                return acc;
            }, {}));
        },
        get_data(){
            this.isLoading = true
            try {
                axios.get('/api/inventarios').then(res => {
                    this.articulos_mes = res.data.datos_mes;
                    this.articulos_dia = res.data.datos_dia;
                    //console.log(this.articulos_mes)
                    this.isLoading = false
                    this.$toasted.success('Datos cargados!');
                })
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false
            }
        },
        formatNumber(num) {
            num = parseInt(num, 10);

            // Verificar si la conversión fue exitosa (parseInt puede devolver NaN en ciertos casos)
            if (isNaN(num)) {
                return 0;  // Retornar 0 si la conversión falla
            }
            if (num==0) {
                return '$0';  // Retornar 0 si la conversión falla
            }
            if(true){
                return num ? num.toLocaleString("es-CL", {style: "currency", currency: "CLP"}) : null;
            }else{
                return Math.round(num)
            }
        },
    },
    mounted() {
        axios.get("/api/pedidos_por_dia").then(res => {
            if(res.data.estado){
                this.categorias=res.data.fechas
                this.series_canal=res.data.series_canal
                this.series_tipo_ingreso=res.data.series_tipo_ingreso
                this.datosDiasListos=true
                //console.log(this.series_tipo_ingreso)
            }
        });   
        axios.get("/api/get_ventas_mes").then(res => {
            if(res.data.estado){
                // console.log(res.data.datosGrafico)
                this.meses=res.data.datosGrafico.map(item => item.fecha);
                this.ingresos_general = [{name:'Ventas',data:res.data.datosGrafico.map(item => parseInt(item.total_venta))}
                //,{name:'egresos',data:[100,1000,10000,10000,1000,20000,30000,40000,405,2234,5556,9000]}
                ];
                const datosPorAño = res.data.datosGrafico.reduce((acc, item) => {
                    const year = item.fecha.split(' ')[1]; // Extraer el año de la fecha
                    if (!acc[year]) acc[year] = []; // Inicializar si no existe
                    acc[year].push(parseInt(item.total_venta || 0)); // Agregar los datos
                    return acc;
                }, {});

                // Convertir el objeto agrupado en series para el gráfico
                this.ingresos_general = Object.keys(datosPorAño).map(year => ({
                    name: `Ventas ${year}`,
                    data: datosPorAño[year]
                }));
                console.log(this.ingresos_general)
                this.totalVentasMesAnterior = parseInt(res.data.totalVentasMesAnterior);
                this.productos_mas_vendidos = res.data.productos_mas_vendidos

                const top10Productos = [...(this.productos_mas_vendidos || [])]
                    .sort((a, b) => (parseFloat(b.total_vendido) || 0) - (parseFloat(a.total_vendido) || 0))
                    .slice(0, 10);
                this.top10ProductosChart.chartOptions.xaxis.categories = top10Productos.map(p => p.name);
                this.top10ProductosChart.series[0].data = top10Productos.map(p => parseFloat(p.total_vendido) || 0);

                let productosAgrupados = {Waffles:[],Completos:[],Cafes:[]}
                productosAgrupados = this.agruparProductosPorTipo(this.productos_mas_vendidos);
                    //Waffles
                let nombresProductos = productosAgrupados.Waffles.slice(0, 10).map(producto => producto.name);
                let cantidadesVendidas = productosAgrupados.Waffles.slice(0, 10).map(producto => producto.total_vendido);
                this.barChart_Waffles.chartOptions.xaxis.categories = nombresProductos;
                this.barChart_Waffles.series[0].name = "Ventas";
                this.barChart_Waffles.series[0].data = cantidadesVendidas;
                    // Completos
                nombresProductos = productosAgrupados.Completos.slice(0, 10).map(producto => producto.name);
                cantidadesVendidas = productosAgrupados.Completos.slice(0, 10).map(producto => producto.total_vendido);
                this.barChart_Completos.chartOptions.xaxis.categories = nombresProductos;
                this.barChart_Completos.series[0].name = "Ventas";
                this.barChart_Completos.series[0].data = cantidadesVendidas;
                    // Cafes
                nombresProductos = productosAgrupados.Cafes.slice(0, 10).map(producto => producto.name);
                cantidadesVendidas = productosAgrupados.Cafes.slice(0, 10).map(producto => producto.total_vendido);
                this.barChart_Cafes.chartOptions.xaxis.categories = nombresProductos;
                this.barChart_Cafes.series[0].name = "Ventas";
                this.barChart_Cafes.series[0].data = cantidadesVendidas;
                //mostrar graficos
                this.datos_hoy.totalVentasHoy=res.data.totalVentasHoy
                this.datos_hoy.totalVentasHoy_turnoA=res.data.totalVentasHoy_turnoA
                this.datos_hoy.totalVentasHoy_turnoB=res.data.totalVentasHoy_turnoB
                this.datos_hoy.totalVentasHoy_getnet=res.data.totalVentasHoy_getnet
                this.datos_hoy.totalVentasHoy_efectivo=res.data.totalVentasHoy_efectivo
                this.datos_hoy.totalVentasHoy_online=res.data.totalVentasHoy_online
                this.datos_hoy.totalVentasHoy_junaeb=res.data.totalVentasHoy_junaeb
                this.datos_hoy.totalVentasHoy_transferencia=res.data.totalVentasHoy_transferencia
                //console.log(this.datos_hoy.totalVentasHoy_junaeb)
                this.datosListos=true
            }
        });
    },
    created(){
        this.get_data()
    }

};

</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card mb-4">
                    <div class="card-body">
                        <div class="col-md-12 mb-2">
                            <h5>Selecciona el rango de fechas:</h5>
                        </div>
                        <div class="col-md-12 mt-4">
                            <date-picker
                                v-model="dates"
                                range
                                format="DD-MM-YYYY"
                                value-type="format"
                                input-class="form-control"
                                placeholder="Selecciona el rango de fechas"
                            />
                        </div>
                        <br>
                        <!-- Botón de Exportar -->
                        <div class="col-md-12 d-flex align-items-end">
                            <button class="btn btn-primary w-100" @click="exportData">
                                Exportar datos de ventas
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div v-if="articulos_dia.length > 0 && datosListos" class="col-lg-12 align-self-center">
                <div class="card mb-4">
                    <div class="text-lg-center mt-4 mt-lg-0">
                        <h5 class="m-4 text-lg-left">Métricas Inventario Anual</h5>
                        <div class="row">
                                <div class="col-2 mt-2 mb-2">
                                    <div>
                                        <p class="text-muted text-truncate">
                                            Total Panes
                                        </p>
                                        <h4 class="fas fa-bread-slice" style="color: brown;"></h4>
                                        <h5 class="mb-0">{{ Math.abs(articulos_dia[0].stock) }}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-2">
                                    <div>
                                        <p class="text-muted text-truncate">
                                            Total Hamburguesas
                                        </p>
                                        <h4 class="fas fa-cookie" style="color: rosybrown"></h4>
                                        <h5 class="mb-0">{{ Math.abs(articulos_dia[1].stock) }}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-2">
                                    <div>
                                        <p class="text-muted text-truncate">
                                            Total Quesos
                                        </p>
                                        <h4 class="fas fa-cheese" style="color: gold;"></h4>
                                        <h5 class="mb-0">{{ Math.abs(articulos_dia[2].stock) }}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-2">
                                    <div>
                                        <p class="text-muted text-truncate">
                                            Venta Turno A
                                        </p>
                                        <h4 class="fas fa-calendar-day" style="color: green"></h4>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy_turnoA)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-2">
                                    <div>
                                        <p class="text-muted text-truncate">
                                            Venta Turno B
                                        </p>
                                        <h4 class="fas fa-calendar-day" style="color: green"></h4>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy_turnoB)}}</h5>
                                    </div>
                                </div>
                            </div>
                            <h5 class="m-4 text-lg-left">Flujo de caja diario</h5>
                            <div class="row">
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total Efectivo
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy_efectivo)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total GetNet
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy_getnet)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total Pago Online
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy_online)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total Transferencia
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy_transferencia)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total Junaeb
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy_junaeb)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Venta total
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy)}}</h5>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>                
            </div> -->
            <!-- <div class="col-lg-12">           
                <div class="card mb-4">
                    <div class="card-body">
                        <h5 class="m-2 text-lg-left">Métricas ventas</h5>
                        <div class="row"></div>
                            <div class="table-responsive mb-0">
                                <b-table class="table-nowrap" :items="articulos_mes.filter(a=> a.def=='Ingredientes')" :fields="fields"
                                    responsive="sm" :per-page="perPage" :current-page="currentPage"
                                    :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter"
                                    :filter-included-fields="filterOn" @filtered="onFiltered">
                                    <template v-slot:cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>
                                    <template v-slot:cell(nombre)="data">
                                        {{ data.item.name }}
                                    </template>
                                    <template v-slot:cell(stock_mes_anterior)="data">
                                        {{ - data.item.stock_mes_anterior }}
                                    </template>
                                    <template v-slot:cell(stock_mes)="data">
                                        {{ - data.item.stock_mes }}
                                    </template>
                                     <template v-slot:cell(acciones)="data">
                                        <b-button size="sm" variant="primary"
                                            @click="ver_modal_producto('editar', data.item)"><i
                                                class="fas fa-edit"></i></b-button>
                                        <b-button size="sm" variant="danger"
                                            @click="eliminar8(data.item)"><i
                                                class="fas fa-trash"></i></b-button>
                                    </template>
                                </b-table>
                            </div>
                    </div>
                </div>
            </div> -->
            <div class="col-lg-12">           
                <div class="card mb-4">
                    <div class="card-body">
                        <h5 class="m-2 text-lg-left">Métricas Ingreso/Stock</h5>
                        <div class="row"></div>
                            <div class="table-responsive mb-0">
                                <b-table class="table-nowrap" :items="articulos_mes" :fields="fields"
                                    responsive="sm" :per-page="perPage" :current-page="currentPage"
                                    :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter"
                                    :filter-included-fields="filterOn" @filtered="onFiltered">
                                    <template v-slot:cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>
                                    <template v-slot:cell(nombre)="data">
                                        {{ data.item.name }}
                                    </template>
                                    <template v-slot:cell(ingresos_mes_anterior)="data">
                                        {{ data.item.ingresos_mes_anterior }}
                                    </template>
                                    <template v-slot:cell(stock_mes)="data">
                                        {{ data.item.ingresos_mes }}
                                    </template>
                                    <!-- <template v-slot:cell(acciones)="data">
                                        <b-button size="sm" variant="primary"
                                            @click="ver_modal_producto('editar', data.item)"><i
                                                class="fas fa-edit"></i></b-button>
                                        <b-button size="sm" variant="danger"
                                            @click="eliminar8(data.item)"><i
                                                class="fas fa-trash"></i></b-button>
                                    </template> -->
                                </b-table>
                            </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-12" v-if="false">           
                <div class="card mb-4">
                    <div class="card-body">
                        <h5>Productos más vendidos por categoría (mensual)</h5>
                        <br>
                        <div class="row">
                            <div class="col-lg-4">
                                <h6>Waffles</h6>
                                <apexchart v-if="datosListos"
                                class="apex-charts"
                                height="350"
                                type="bar"
                                dir="ltr"
                                :series="barChart_Waffles.series"
                                :options="barChart_Waffles.chartOptions"
                                ></apexchart>
                            </div>
                            <div class="col-lg-4">
                                <h6>Completos</h6>
                                <apexchart v-if="datosListos"
                                class="apex-charts"
                                height="350"
                                type="bar"
                                dir="ltr"
                                :series="barChart_Completos.series"
                                :options="barChart_Completos.chartOptions"
                                ></apexchart>
                            </div>
                            <div class="col-sm-4">
                                <h6>Cafes</h6>
                                <apexchart v-if="datosListos"
                                class="apex-charts"
                                height="350"
                                type="bar"
                                dir="ltr"
                                :series="barChart_Cafes.series"
                                :options="barChart_Cafes.chartOptions"
                                ></apexchart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 mb-4">           
                    <Visitors v-if="datosListos" :series_data="ingresos_general" :series_x="eje_x_ingresos" title="Ingresos Generales" :graphColor="'#556ee6'" :total_año_anterior="0" :totalVentasMesAnterior="totalVentasMesAnterior"/>
            </div>
            <div class="col-lg-12">           
                <div class="card mb-4">
                    <div class="card-body">
                        <h5 class="m-2 text-lg-left">Top 10 productos vendidos (mes actual)</h5>
                        <apexchart
                            v-if="datosListos"
                            class="apex-charts"
                            height="380"
                            type="bar"
                            dir="ltr"
                            :series="top10ProductosChart.series"
                            :options="top10ProductosChart.chartOptions"
                        ></apexchart>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">           
                <div class="card mb-4">      
                        <Barras v-if="datosDiasListos" :seriesData="series_canal" :categorias="categorias" :colores="colores1" :title="'Ventas diarias por canal'"/>
                </div>
            </div>
            <div class="col-lg-12 mb-4">           
                    <Barras v-if="datosDiasListos" :seriesData="series_tipo_ingreso" :categorias="categorias" :colores="colores2" :title="'Ventas diarias por metodo de pago'"/>
            </div>
        </div>
    </Layout>
</template>